import { useAlertBanner } from '@src/contexts/alert-banner-context'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

export const useSystemLockBanner = (isLockedBySystem: boolean) => {
  const { showBanner, hideBanner } = useAlertBanner()
  const { t } = useTranslation()

  useEffect(() => {
    if (!isLockedBySystem) return
    showBanner(t('common.lockTooltip.lockedBySystem'))
    return () => hideBanner()
  }, [isLockedBySystem, showBanner, hideBanner, t])
}
